import deepFreeze from 'deep-freeze';
import serviceFactory from '@/services/serviceFactory';
import financeServiceOLD, { PAYOUT_THRESHOLD, FinanceDocumentStatus, translateFinanceDocumentStatus } from './financeServiceOLD';
import globalData from '@/store/globalData';
import { EndpointError } from '@/services/errorService';

export { PAYOUT_THRESHOLD, FinanceDocumentStatus, translateFinanceDocumentStatus };

export const ENDPOINTS = deepFreeze({
    PUBLISHER_FINANCE_DOCUMENTS: {
        URI: () => '/api/v1/publisher-finance-documents',
        methods: ['get'],
        default: {},
    },
    PUBLISHER_FINANCE_DOCUMENTS_STATUSES: {
        URI: () => '/api/v1/publisher-finance-documents/statuses',
        methods: ['put'],
        default: {},
        cacheToClear: ['/api/v1/publisher-finance-documents'],
    },
    FINANCE_DOCUMENTS_DOWNLOAD: {
        URI: () => '/api/v1/finance-documents/{{id}}/download',
        methods: ['get'],
    },
    FINANCE_DOCUMENTS: {
        URI: () => {
            if (globalData.user.isRoleAdmin) return '/api/v1/finance-documents';
            if (globalData.user.isRoleWidgeter) return '/api/v1/users/{{userId}}/finance-documents';
            throw new EndpointError();
        },
        methods: ['get'],
        formatter: data => data?.items || [],
    },
});

export default {
    ...financeServiceOLD,
    ...serviceFactory.build(ENDPOINTS),
};
